import { Card, Row, Col } from 'react-bootstrap'
import { Organization } from 'interfaces/organization'
import { OrganizationSettingsCard } from './organization-settings-card'
import { OrganizationAddOnsCard } from './organization-add-ons-card'
import { OrganizationEntitlementsCard } from './organization-entitlements-card'
import { OrganizationPrimaryUseCaseCard } from './organization-primary-use-case'
import { OrganizationTeamsCard } from './organization-teams-card'
import { OrganizationUnClaimedCard } from './organization-unclaimed-card'
import { OrganizationProductCredits } from './organization-product-credits-card'
import { OrganizationRecentCustomerIoEmail } from './organization-recent-customer-io-email'

interface OrganizationAllSettingsCardProps {
  org: Organization | undefined
  orgId: string
  handleSaveFieldClick: (org: Partial<Organization>, field: string) => void
}

export const OrganizationAllSettingsCard = ({
  org,
  orgId,
  handleSaveFieldClick,
}: OrganizationAllSettingsCardProps) => {
  return (
    <div className="mt-4">
      <h3 className="mb-2">Linq One Settings</h3>
      <Row>
        <Col lg="6">
          <OrganizationSettingsCard org={org} orgId={orgId} />
        </Col>
        <Col lg="6">
          <OrganizationAddOnsCard orgId={orgId} />
          <OrganizationEntitlementsCard
            org={org}
            handleSaveFieldClick={handleSaveFieldClick}
          />
          <OrganizationPrimaryUseCaseCard org={org} orgId={orgId} />
        </Col>
      </Row>

      <Row>
        <Col lg="6">
          <OrganizationTeamsCard org={org} orgId={orgId} />
        </Col>
        <Col lg="6">
          <OrganizationUnClaimedCard orgId={orgId} />
        </Col>
      </Row>

      <OrganizationProductCredits orgId={orgId} />

      <OrganizationRecentCustomerIoEmail orgId={orgId} />
    </div>
  )
}
